"use client";
import { FallBackPage, ThemeModeWrapper } from "@highway/design-system";
import "./global.css";

const NotFound = () => {
    return (
        <ThemeModeWrapper>
            <FallBackPage page="notFound" />
        </ThemeModeWrapper>
    );
};
export default NotFound;
